import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { uploadStatusPresentation } from '@/constants/upload';
import { cn } from '@/lib/utils';
import type { UploadStatus } from '@hooks/useDocumentUpload';

interface UploadStatusBadgeProps {
  status: UploadStatus;
  /** Only the `uploading` label interpolates it — "アップロード中... 42%". */
  progress?: number;
  className?: string;
}

const UploadStatusBadge: React.FC<UploadStatusBadgeProps> = ({ status, progress, className }) => {
  const { t } = useTranslation();
  const { badgeVariant, badgeClass, labelKey } = uploadStatusPresentation(status);

  return (
    <Badge
      variant={badgeVariant}
      className={cn(
        'revy-cjk revy-figure shrink-0 px-2 py-0 text-[11px] font-medium leading-[1.5]',
        badgeClass,
        className,
      )}
    >
      {t(labelKey, { progress: Math.round(progress ?? 0) })}
    </Badge>
  );
};

export default UploadStatusBadge;
